import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Massages from "@/pages/Massages";
import MassageDetail from "@/pages/MassageDetail";
import ServiceDetail from "@/pages/ServiceDetail";
import Institut from "@/pages/Institut";
import Vajacial from "@/pages/Vajacial";
import MentionsLegales from "@/pages/MentionsLegales";
import Confidentialite from "@/pages/Confidentialite";
import { CookieConsent } from "@/components/site/CookieConsent";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const el = document.getElementById(hash.replace("#", ""));
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/massages" element={<Massages />} />
        <Route path="/massages/:slug" element={<MassageDetail />} />
        <Route path="/prestations/:slug" element={<ServiceDetail />} />
        <Route path="/institut" element={<Institut />} />
        <Route path="/vajacial" element={<Vajacial />} />
        <Route path="/mentions-legales" element={<MentionsLegales />} />
        <Route path="/politique-confidentialite" element={<Confidentialite />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
